<template>
  <div class="overflow-hidden -mt-20">
    <div id="section-hero" class="hero">
      <div class="container flex flex-col justify-center items-center z-10">
        <div>
          <h3 id="section-hero-title" class="hero-title">
            Entrepreneurs, you aren’t solo.<br />Get answers when you’re stuck.
          </h3>
          <h1 id="section-hero-text" class="hero-description">
            Connect and talk with experts on the topic you need.
          </h1>
        </div>
        <!-- input -->
        <InputAutocomplete
          id="section-hero-input"
          v-model="searchValue"
          class="inputautocomplete"
          :suggestions="searchSuggestions"
          :example-text="
            'eg: “Entrepeneurship”, “Marketing”, “Engineering” ...'
          "
          @onEnter="onSuggestionsEnter"
          @onSelectSuggestion="onSelectSuggestion"
        />
      </div>
    </div>

    <!-- 3 advantages -->
    <div
      id="section-advantage"
      class="container text-center flex flex-col lg:mt-16 mt-20 md:flex-row"
    >
      <div id="section-advantage-1" class="max-w-xs mx-auto opacity-0">
        <div class="mb-6">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mx-auto"
          >
            <path
              d="M20.2623 21.1878C20.2615 22.6321 19.7604 24.0316 18.8443 25.1482C17.9282 26.2648 16.6536 27.0297 15.2373 27.3128L10.4248 28.2753C10.224 28.3155 10.0164 28.3058 9.82022 28.2469C9.62405 28.1881 9.44535 28.0819 9.29983 27.9378L8.41233 27.0628C8.17988 26.8306 7.99549 26.5549 7.86968 26.2514C7.74387 25.9479 7.67911 25.6226 7.67911 25.2941C7.67911 24.9655 7.74387 24.6402 7.86968 24.3367C7.99549 24.0332 8.17988 23.7575 8.41233 23.5253L10.2123 21.7128C9.57682 21.1712 8.98344 20.582 8.43733 19.9503L6.63733 21.7503C6.40514 21.9827 6.12942 22.1671 5.82593 22.293C5.52243 22.4188 5.19711 22.4835 4.86858 22.4835C4.54004 22.4835 4.21472 22.4188 3.91122 22.293C3.60773 22.1671 3.33201 21.9827 3.09983 21.7503L2.22483 20.8753C2.0785 20.731 1.97002 20.5529 1.90897 20.3566C1.84792 20.1604 1.83619 19.9521 1.87483 19.7503L2.83733 14.9253C3.12041 13.509 3.8853 12.2344 5.00192 11.3183C6.11855 10.4023 7.518 9.90117 8.96233 9.9003H10.0373C11.7911 7.36468 14.2266 5.37707 17.0623 4.16713C19.898 2.9572 23.0182 2.57434 26.0623 3.0628C26.3225 3.10431 26.563 3.22699 26.7493 3.41331C26.9356 3.59964 27.0583 3.84009 27.0998 4.1003C27.6008 7.14634 27.2224 10.2721 26.009 13.1106C24.7957 15.9491 22.7978 18.3825 20.2498 20.1253V21.1878H20.2623ZM14.7498 24.8628C15.5992 24.6924 16.3633 24.2333 16.9125 23.5634C17.4616 22.8934 17.7619 22.054 17.7623 21.1878V19.4378C17.764 19.2275 17.8187 19.021 17.9214 18.8375C18.0241 18.6539 18.1715 18.4993 18.3498 18.3878C20.5129 17.0293 22.2565 15.097 23.3864 12.8062C24.5164 10.5154 24.9884 7.95596 24.7498 5.4128C22.2057 5.16553 19.643 5.63364 17.3506 6.76439C15.0582 7.89515 13.127 9.64362 11.7748 11.8128C11.6622 11.9929 11.5056 12.1414 11.3197 12.2442C11.1338 12.347 10.9248 12.4007 10.7123 12.4003H8.96233C8.09784 12.4001 7.25984 12.6986 6.59015 13.2453C5.92046 13.792 5.46022 14.5533 5.28733 15.4003L4.46233 19.5753L4.87483 19.9878L7.67483 17.1878C7.80269 17.0592 7.95699 16.96 8.12703 16.897C8.29707 16.8341 8.47877 16.8088 8.65954 16.8231C8.8403 16.8374 9.0158 16.8908 9.17385 16.9797C9.3319 17.0686 9.46872 17.1908 9.57483 17.3378C10.4696 18.5946 11.568 19.693 12.8248 20.5878C12.9719 20.6939 13.0941 20.8307 13.1829 20.9888C13.2718 21.1468 13.3253 21.3223 13.3395 21.5031C13.3538 21.6839 13.3286 21.8656 13.2656 22.0356C13.2026 22.2056 13.1034 22.3599 12.9748 22.4878L10.1748 25.2878L10.5873 25.7003L14.7498 24.8628V24.8628ZM18.7498 12.5003C18.4183 12.5003 18.1004 12.3686 17.8659 12.1342C17.6315 11.8998 17.4998 11.5818 17.4998 11.2503C17.4998 10.9188 17.6315 10.6008 17.8659 10.3664C18.1004 10.132 18.4183 10.0003 18.7498 10.0003C19.0813 10.0003 19.3993 10.132 19.6337 10.3664C19.8681 10.6008 19.9998 10.9188 19.9998 11.2503C19.9998 11.5818 19.8681 11.8998 19.6337 12.1342C19.3993 12.3686 19.0813 12.5003 18.7498 12.5003Z"
              fill="#292D3D"
            />
          </svg>
        </div>
        <h4 class="font-medium text-black mb-3">
          Understand and move faster.
        </h4>
        <p class="text-gray-600">
          Learning from experts can help you learn a subject faster, with more
          depth.
        </p>
      </div>
      <div
        id="section-advantage-2"
        class="max-w-xs mx-auto mt-12 md:mt-0 md:ml-6 opacity-0"
      >
        <div class="mb-6">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mx-auto"
          >
            <path
              d="M13.75 25V22.4C12.6421 22.2119 11.5906 21.7773 10.6732 21.1282C9.75582 20.4791 8.99604 19.6322 8.45 18.65C7.72759 18.7853 6.98428 18.7605 6.2725 18.5773C5.56071 18.3942 4.89777 18.0571 4.33042 17.5898C3.76307 17.1226 3.30512 16.5366 2.98885 15.8732C2.67259 15.2097 2.50572 14.485 2.5 13.75V7.5C2.5 6.125 3.625 5 5 5H7.5C7.5 3.625 8.625 2.5 10 2.5H20C20.663 2.5 21.2989 2.76339 21.7678 3.23223C22.2366 3.70107 22.5 4.33696 22.5 5H25C25.663 5 26.2989 5.26339 26.7678 5.73223C27.2366 6.20107 27.5 6.83696 27.5 7.5V13.75C27.5005 14.4874 27.3379 15.2159 27.0239 15.8831C26.7098 16.5503 26.252 17.1397 25.6834 17.6093C25.1147 18.0788 24.4492 18.4167 23.7346 18.5988C23.02 18.7808 22.274 18.8026 21.55 18.6625C21.0025 19.6424 20.2421 20.4869 19.3249 21.1337C18.4076 21.7806 17.3568 22.2133 16.25 22.4V25H21.25C21.5815 25 21.8995 25.1317 22.1339 25.3661C22.3683 25.6005 22.5 25.9185 22.5 26.25C22.5 26.5815 22.3683 26.8995 22.1339 27.1339C21.8995 27.3683 21.5815 27.5 21.25 27.5H8.75C8.41848 27.5 8.10054 27.3683 7.86612 27.1339C7.6317 26.8995 7.5 26.5815 7.5 26.25C7.5 25.9185 7.6317 25.6005 7.86612 25.3661C8.10054 25.1317 8.41848 25 8.75 25H13.75ZM22.4 16.25H22.5C23.163 16.25 23.7989 15.9866 24.2678 15.5178C24.7366 15.0489 25 14.413 25 13.75V7.5H22.5V15C22.5 15.425 22.4625 15.8375 22.4 16.25ZM7.6 16.25C7.53206 15.8368 7.49861 15.4187 7.5 15V7.5H5V13.75C4.99973 14.0869 5.06755 14.4204 5.1994 14.7304C5.33124 15.0404 5.52438 15.3206 5.76723 15.5541C6.01007 15.7876 6.2976 15.9696 6.61255 16.0892C6.92751 16.2088 7.26338 16.2635 7.6 16.25ZM10 5V15C10 16.3261 10.5268 17.5979 11.4645 18.5355C12.4021 19.4732 13.6739 20 15 20C16.3261 20 17.5979 19.4732 18.5355 18.5355C19.4732 17.5979 20 16.3261 20 15V5H10Z"
              fill="#292D3D"
            />
          </svg>
        </div>
        <h4 class="font-medium text-black mb-3">
          Expertise tailored to your needs.
        </h4>
        <p class="text-gray-600">
          Each situation is unique and talking 1:1 with an expert is different
        </p>
      </div>
      <div
        id="section-advantage-3"
        class="max-w-xs mx-auto mt-12 md:mt-0 md:ml-6 opacity-0"
      >
        <div class="mb-6">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mx-auto"
          >
            <path
              d="M15 27.5C11.6848 27.5 8.50537 26.183 6.16117 23.8388C3.81696 21.4946 2.5 18.3152 2.5 15C2.5 11.6848 3.81696 8.50537 6.16117 6.16117C8.50537 3.81696 11.6848 2.5 15 2.5C18.3152 2.5 21.4946 3.81696 23.8388 6.16117C26.183 8.50537 27.5 11.6848 27.5 15C27.5 18.3152 26.183 21.4946 23.8388 23.8388C21.4946 26.183 18.3152 27.5 15 27.5V27.5ZM15 25C17.6522 25 20.1957 23.9464 22.0711 22.0711C23.9464 20.1957 25 17.6522 25 15C25 12.3478 23.9464 9.8043 22.0711 7.92893C20.1957 6.05357 17.6522 5 15 5C12.3478 5 9.8043 6.05357 7.92893 7.92893C6.05357 9.8043 5 12.3478 5 15C5 17.6522 6.05357 20.1957 7.92893 22.0711C9.8043 23.9464 12.3478 25 15 25V25ZM10.575 19.425C10.3396 19.1896 10.2074 18.8704 10.2074 18.5375C10.2074 18.2046 10.3396 17.8854 10.575 17.65C10.8104 17.4146 11.1296 17.2824 11.4625 17.2824C11.7954 17.2824 12.1146 17.4146 12.35 17.65C13.0531 18.3523 14.0062 18.7467 15 18.7467C15.9938 18.7467 16.9469 18.3523 17.65 17.65C17.8854 17.4146 18.2046 17.2824 18.5375 17.2824C18.8704 17.2824 19.1896 17.4146 19.425 17.65C19.6604 17.8854 19.7926 18.2046 19.7926 18.5375C19.7926 18.8704 19.6604 19.1896 19.425 19.425C18.8444 20.007 18.1547 20.4688 17.3954 20.7839C16.6361 21.099 15.8221 21.2612 15 21.2612C14.1779 21.2612 13.3639 21.099 12.6046 20.7839C11.8453 20.4688 11.1556 20.007 10.575 19.425V19.425ZM11.25 13.75C10.9185 13.75 10.6005 13.6183 10.3661 13.3839C10.1317 13.1495 10 12.8315 10 12.5C10 12.1685 10.1317 11.8505 10.3661 11.6161C10.6005 11.3817 10.9185 11.25 11.25 11.25C11.5815 11.25 11.8995 11.3817 12.1339 11.6161C12.3683 11.8505 12.5 12.1685 12.5 12.5C12.5 12.8315 12.3683 13.1495 12.1339 13.3839C11.8995 13.6183 11.5815 13.75 11.25 13.75ZM18.75 13.75C18.4185 13.75 18.1005 13.6183 17.8661 13.3839C17.6317 13.1495 17.5 12.8315 17.5 12.5C17.5 12.1685 17.6317 11.8505 17.8661 11.6161C18.1005 11.3817 18.4185 11.25 18.75 11.25C19.0815 11.25 19.3995 11.3817 19.6339 11.6161C19.8683 11.8505 20 12.1685 20 12.5C20 12.8315 19.8683 13.1495 19.6339 13.3839C19.3995 13.6183 19.0815 13.75 18.75 13.75Z"
              fill="#292D3D"
            />
          </svg>
        </div>
        <h4 class="font-medium text-black mb-3">
          Anticipate problems, before.
        </h4>
        <p class="text-gray-600">
          Talking with experts can help you identify problems before they
          happen.
        </p>
      </div>
    </div>

    <!-- features -->
    <div
      id="section-feature"
      class="container mt-40 md:mt-64 flex flex-col items-center"
    >
      <h2
        id="section-feature-title"
        class="font-serif text-2xl md:text-4xl text-center text-black leading-tight tracking-tight opacity-0"
      >
        Find the right expert, and talk.<br />As simple as that.
      </h2>
      <nuxt-link
        id="section-feature-button"
        class="flex flex-row items-center justify-center text-pink-600 text-sm md:text-lg mt-6 text-center mx-auto opacity-0"
        :to="{ name: 'signup' }"
      >
        Join the beta
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="fill-current ml-2"
        >
          <path
            d="M12.393 8.66635H1.99967C1.82286 8.66635 1.65329 8.59611 1.52827 8.47109C1.40325 8.34606 1.33301 8.17649 1.33301 7.99968C1.33301 7.82287 1.40325 7.6533 1.52827 7.52828C1.65329 7.40325 1.82286 7.33302 1.99967 7.33302H12.393L8.85967 3.79968C8.79035 3.73941 8.73422 3.66547 8.69482 3.58248C8.65542 3.4995 8.6336 3.40927 8.63072 3.31745C8.62784 3.22563 8.64397 3.13421 8.67809 3.04892C8.71221 2.96363 8.76359 2.88631 8.82901 2.82181C8.89442 2.75732 8.97246 2.70704 9.05823 2.67413C9.14399 2.64122 9.23564 2.62639 9.3274 2.63057C9.41917 2.63476 9.50908 2.65786 9.5915 2.69843C9.67392 2.739 9.74706 2.79617 9.80634 2.86635L14.473 7.53302C14.5952 7.65763 14.6636 7.82518 14.6636 7.99968C14.6636 8.17418 14.5952 8.34173 14.473 8.46635L9.80634 13.133C9.67959 13.2432 9.51593 13.3015 9.34806 13.2962C9.1802 13.291 9.02051 13.2225 8.90091 13.1046C8.78131 12.9867 8.71063 12.828 8.70298 12.6602C8.69534 12.4925 8.7513 12.328 8.85967 12.1997L12.393 8.66635V8.66635Z"
            fill="#CB3F66"
          />
        </svg>
      </nuxt-link>

      <div class="flex flex-col md:flex-row items-center justify-center mt-16">
        <!-- img demo -->
        <div class="demo-container mb-20 md:mb-0 md:mr-20">
          <div id="section-feature-demo" class="demo-video-container opacity-0">
            <img :src="require('~/assets/images/demo-img.jpg')" alt="" />
          </div>
        </div>
        <!-- demo values -->
        <div>
          <div id="section-feature-card-1" class="feature-card opacity-0">
            <span>01</span>
            <h5>Search by skills or just browse.</h5>
            <p>
              Do you have a precise question on a topic? Search for that skill.
              If you’re just curious, explore and find the right expert for you.
            </p>
          </div>
          <div id="section-feature-card-2" class="feature-card opacity-0">
            <span>02</span>
            <h5>Book when you’re free.</h5>
            <p>
              If the expert has set his availability just pick one. Otherwise,
              select 3 time slots when you’re free and let the expert pick one.
            </p>
          </div>
          <div id="section-feature-card-3" class="feature-card opacity-0">
            <span>03</span>
            <h5>Enjoy the conversation.</h5>
            <p>
              Prepare some questions in advance or just chat, it’s up to you.
              Show up on time, be nice, they’re here to help you. Have a great
              moment.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- experts title -->
    <div id="section-experts">
      <div class="flex flex-col items-center container mt-40 md:mt-64 mx-auto">
        <h2 id="section-experts-title" class="container-title opacity-0">
          Carefully selected Experts
        </h2>
        <p
          id="section-experts-text"
          class="container-text max-w-md md:max-w-xl opacity-0"
        >
          All of our experts are reviewed to meet a certain standard. Social
          media fame or degrees aren't taken into account. We select experts by
          their accomplishments or experience, and because they share our values
          of empathy, determination and resilience.
        </p>

        <div id="section-experts-button" class="mt-10 opacity-0">
          <nuxt-link class="button-outline" :to="{ name: 'experts' }">
            Apply as an expert
          </nuxt-link>
        </div>
      </div>
      <!-- experts "container" -->
      <div id="section-experts-demo" class="fake-results">
        <div
          v-for="(profil, idx) in profilesData"
          :id="`section-experts-demo-${idx + 1}`"
          :key="`${profil.name}-${idx}`"
          class="fake-card opacity-0"
        >
          <div class="img-container mr-5 overflow-hidden">
            <img
              :src="profil.imageSrc"
              :alt="profil.imageAlt"
              loading="lazy"
              class="absolute inset-0 w-full h-full rounded object-cover overflow-hidden"
            />
          </div>
          <div>
            <div class="text-lg text-black font-medium whitespace-no-wrap">
              {{ profil.name }}
            </div>
            <div
              class="font-medium text-sm text-gray-600 mt-px whitespace-no-wrap"
            >
              {{ profil.job }}
            </div>
            <!-- badges -->
            <div class="flex mt-4">
              <div
                v-for="(key, badgeIndex) in profil.keywords"
                :key="key"
                class="flex flex-row flex-no-wrap items-center card-badge bg-green-200 rounded-full text-green-600 text-2xs font-medium leading-none whitespace-no-wrap mr-2"
              >
                <span v-if="badgeIndex === 0" class="mr-1">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.5 10V8.96C5.05683 8.88477 4.63623 8.71092 4.26928 8.45129C3.90233 8.19166 3.59842 7.85288 3.38 7.46C3.09103 7.51413 2.79371 7.50421 2.509 7.43094C2.22428 7.35767 1.95911 7.22283 1.73217 7.03594C1.50523 6.84905 1.32205 6.61465 1.19554 6.34927C1.06904 6.08388 1.00229 5.79398 1 5.5V3C1 2.45 1.45 2 2 2H3C3 1.45 3.45 1 4 1H8C8.26522 1 8.51957 1.10536 8.70711 1.29289C8.89464 1.48043 9 1.73478 9 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V5.5C11.0002 5.79497 10.9352 6.08634 10.8095 6.35323C10.6839 6.62011 10.5008 6.8559 10.2733 7.0437C10.0459 7.2315 9.77969 7.36666 9.49385 7.4395C9.20801 7.51234 8.9096 7.52105 8.62 7.465C8.40102 7.85695 8.09686 8.19475 7.72994 8.45349C7.36303 8.71224 6.94272 8.88533 6.5 8.96V10H8.5C8.63261 10 8.75979 10.0527 8.85355 10.1464C8.94732 10.2402 9 10.3674 9 10.5C9 10.6326 8.94732 10.7598 8.85355 10.8536C8.75979 10.9473 8.63261 11 8.5 11H3.5C3.36739 11 3.24021 10.9473 3.14645 10.8536C3.05268 10.7598 3 10.6326 3 10.5C3 10.3674 3.05268 10.2402 3.14645 10.1464C3.24021 10.0527 3.36739 10 3.5 10H5.5ZM8.96 6.5H9C9.26522 6.5 9.51957 6.39464 9.70711 6.20711C9.89464 6.01957 10 5.76522 10 5.5V3H9V6C9 6.17 8.985 6.335 8.96 6.5ZM3.04 6.5C3.01282 6.33473 2.99945 6.16749 3 6V3H2V5.5C1.99989 5.63476 2.02702 5.76814 2.07976 5.89215C2.1325 6.01616 2.20975 6.12823 2.30689 6.22163C2.40403 6.31503 2.51904 6.38784 2.64502 6.43567C2.771 6.48351 2.90535 6.50539 3.04 6.5ZM4 2V6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6V2H4Z"
                      fill="#359763"
                    />
                  </svg>
                </span>
                {{ key }}
              </div>
            </div>
            <!-- items bellow -->
            <div class="flex flex-row flex-no-wrap mt-3">
              <div class="flex flex-row flex-no-wrap items-center mr-3">
                <span class="mr-1">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.82 8.18005C2.19011 7.55094 1.76097 6.74913 1.58688 5.87606C1.41279 5.00299 1.50158 4.09791 1.84201 3.27531C2.18244 2.45272 2.75921 1.74958 3.49935 1.25487C4.2395 0.760155 5.10975 0.496094 6 0.496094C6.89026 0.496094 7.76051 0.760155 8.50065 1.25487C9.24079 1.74958 9.81757 2.45272 10.158 3.27531C10.4984 4.09791 10.5872 5.00299 10.4131 5.87606C10.239 6.74913 9.8099 7.55094 9.18 8.18005L6.355 11.0101C6.30852 11.0569 6.25322 11.0941 6.19229 11.1195C6.13136 11.1449 6.06601 11.158 6 11.158C5.934 11.158 5.86864 11.1449 5.80771 11.1195C5.74678 11.0941 5.69148 11.0569 5.645 11.0101L2.82 8.18005V8.18005ZM8.475 7.47505C8.96445 6.98556 9.29776 6.36191 9.43278 5.68299C9.5678 5.00407 9.49846 4.30035 9.23355 3.66083C8.96863 3.02131 8.52002 2.47471 7.94446 2.09014C7.3689 1.70557 6.69222 1.50031 6 1.50031C5.30778 1.50031 4.63111 1.70557 4.05554 2.09014C3.47998 2.47471 3.03138 3.02131 2.76646 3.66083C2.50154 4.30035 2.43221 5.00407 2.56723 5.68299C2.70225 6.36191 3.03555 6.98556 3.525 7.47505L6 9.95005L8.475 7.47505ZM6 7.00005C5.46957 7.00005 4.96086 6.78934 4.58579 6.41427C4.21072 6.03919 4 5.53049 4 5.00005C4 4.46962 4.21072 3.96091 4.58579 3.58584C4.96086 3.21077 5.46957 3.00005 6 3.00005C6.53043 3.00005 7.03914 3.21077 7.41422 3.58584C7.78929 3.96091 8 4.46962 8 5.00005C8 5.53049 7.78929 6.03919 7.41422 6.41427C7.03914 6.78934 6.53043 7.00005 6 7.00005ZM6 6.00005C6.26522 6.00005 6.51957 5.8947 6.70711 5.70716C6.89464 5.51962 7 5.26527 7 5.00005C7 4.73484 6.89464 4.48048 6.70711 4.29295C6.51957 4.10541 6.26522 4.00005 6 4.00005C5.73479 4.00005 5.48043 4.10541 5.2929 4.29295C5.10536 4.48048 5 4.73484 5 5.00005C5 5.26527 5.10536 5.51962 5.2929 5.70716C5.48043 5.8947 5.73479 6.00005 6 6.00005Z"
                      fill="#2D3748"
                    />
                  </svg>
                </span>
                <span
                  class="text-black text-2xs font-medium leading-none whitespace-no-wrap"
                >
                  {{ profil.city }}
                </span>
              </div>
              <div class="flex flex-row flex-no-wrap items-center mr-3">
                <span class="mr-1">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 11C4.67392 11 3.40215 10.4732 2.46447 9.53553C1.52678 8.59785 1 7.32608 1 6C1 4.67392 1.52678 3.40215 2.46447 2.46447C3.40215 1.52678 4.67392 1 6 1C7.32608 1 8.59785 1.52678 9.53553 2.46447C10.4732 3.40215 11 4.67392 11 6C11 7.32608 10.4732 8.59785 9.53553 9.53553C8.59785 10.4732 7.32608 11 6 11V11ZM6 10C7.06087 10 8.07828 9.57857 8.82843 8.82843C9.57857 8.07828 10 7.06087 10 6C10 4.93913 9.57857 3.92172 8.82843 3.17157C8.07828 2.42143 7.06087 2 6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6C2 7.06087 2.42143 8.07828 3.17157 8.82843C3.92172 9.57857 4.93913 10 6 10V10ZM6.5 5.795L7.77 7.06C7.86415 7.15415 7.91705 7.28185 7.91705 7.415C7.91705 7.54815 7.86415 7.67585 7.77 7.77C7.67585 7.86415 7.54815 7.91705 7.415 7.91705C7.28185 7.91705 7.15415 7.86415 7.06 7.77L5.65 6.35C5.55579 6.25768 5.50188 6.13188 5.5 6V4C5.5 3.86739 5.55268 3.74021 5.64645 3.64645C5.74021 3.55268 5.86739 3.5 6 3.5C6.13261 3.5 6.25979 3.55268 6.35355 3.64645C6.44732 3.74021 6.5 3.86739 6.5 4V5.795Z"
                      fill="#2D3748"
                    />
                  </svg>
                </span>
                <span
                  class="text-black text-2xs font-medium leading-none whitespace-no-wrap"
                >
                  {{ profil.averageDuration }}
                </span>
              </div>
              <div class="flex flex-row flex-no-wrap items-center">
                <span class="mr-1">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.55807 12.8215C3.46147 12.8723 3.35255 12.8949 3.2437 12.8869C3.13485 12.8789 3.03043 12.8405 2.94232 12.7761C2.85421 12.7117 2.78594 12.6238 2.74526 12.5225C2.70459 12.4213 2.69315 12.3106 2.71224 12.2031L3.31307 8.68563L0.758071 6.20063C0.679318 6.12453 0.623576 6.0278 0.597222 5.92151C0.570868 5.81522 0.574966 5.70366 0.609048 5.59958C0.64313 5.49551 0.705819 5.40314 0.789943 5.33302C0.874067 5.26291 0.976228 5.2179 1.08474 5.20313L4.6139 4.68979L6.1889 1.49313C6.23667 1.3945 6.31125 1.31133 6.4041 1.25313C6.49695 1.19493 6.60432 1.16406 6.7139 1.16406C6.82349 1.16406 6.93085 1.19493 7.02371 1.25313C7.11656 1.31133 7.19114 1.3945 7.2389 1.49313L8.8139 4.68979L12.3489 5.20313C12.4557 5.21961 12.5559 5.26546 12.6382 5.33555C12.7205 5.40564 12.7817 5.49723 12.815 5.60008C12.8482 5.70293 12.8523 5.813 12.8266 5.91802C12.801 6.02303 12.7467 6.11885 12.6697 6.19479L10.1147 8.68563L10.7214 12.2031C10.7413 12.3114 10.7302 12.4231 10.6893 12.5252C10.6484 12.6274 10.5795 12.716 10.4904 12.7806C10.4013 12.8453 10.2958 12.8835 10.186 12.8907C10.0761 12.8979 9.9665 12.8739 9.86974 12.8215L6.71974 11.159L3.55807 12.8215ZM6.44557 9.98063C6.52923 9.93668 6.62232 9.91372 6.71682 9.91372C6.81132 9.91372 6.90441 9.93668 6.98807 9.98063L9.36807 11.2348L8.91307 8.58063C8.89776 8.48776 8.90516 8.39257 8.93461 8.30319C8.96407 8.2138 9.01472 8.13286 9.08224 8.06729L11.0072 6.18896L8.34724 5.79813C8.25331 5.78558 8.16386 5.75034 8.08662 5.69545C8.00937 5.64057 7.94666 5.56769 7.9039 5.48313L6.7139 3.06813L5.5239 5.48313C5.4817 5.56695 5.41989 5.63936 5.34373 5.6942C5.26756 5.74904 5.17929 5.78469 5.0864 5.79813L2.42057 6.18896L4.34557 8.06729C4.41413 8.13229 4.46587 8.21297 4.49636 8.30239C4.52684 8.3918 4.53515 8.48729 4.52057 8.58063L4.05974 11.2348L6.44557 9.98063Z"
                      fill="#CB3F66"
                    />
                    <path
                      d="M6.44557 9.98063C6.52923 9.93668 6.62232 9.91372 6.71682 9.91372C6.81132 9.91372 6.90441 9.93668 6.98807 9.98063L9.36807 11.2348L8.91307 8.58063C8.89776 8.48776 8.90516 8.39257 8.93461 8.30319C8.96407 8.2138 9.01472 8.13286 9.08224 8.06729L11.0072 6.18896L8.34724 5.79813C8.25331 5.78558 8.16386 5.75034 8.08662 5.69545C8.00937 5.64057 7.94666 5.56769 7.9039 5.48313L6.7139 3.06813L5.5239 5.48313C5.4817 5.56695 5.41989 5.63936 5.34373 5.6942C5.26756 5.74904 5.17929 5.78469 5.0864 5.79813L2.42057 6.18896L4.34557 8.06729C4.41413 8.13229 4.46587 8.21297 4.49636 8.30239C4.52684 8.3918 4.53515 8.48729 4.52057 8.58063L4.05974 11.2348L6.44557 9.98063Z"
                      fill="#CB3F66"
                    />
                  </svg>
                </span>
                <span
                  class="text-black text-2xs font-medium leading-none whitespace-no-wrap"
                >
                  {{ profil.rating.note }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer class="z-10">
      <div id="section-footer" class="container z-10">
        <div class="mx-auto mt-24 md:mt-40 mb-40">
          <h2
            id="section-footer-title"
            class="container-title mx-auto opacity-0"
          >
            Talk, connect, exchange,<br />
            with experts when you need to.
          </h2>
          <p
            id="section-footer-text"
            class="container-text max-w-xs md:max-w-lg mx-auto opacity-0"
          >
            Learning alone online is cool. Learning from other profesionnals is
            great.<br class="sm:hidden" />
            Join the club now!
          </p>
          <div
            id="section-footer-button"
            class="flex flex-col items-center mt-8 md:mt-10 opacity-0 mx-auto"
          >
            <nuxt-link class="button-plain button-sm" :to="{ name: 'signup' }">
              Join the Beta
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="fill-current ml-2"
              >
                <path
                  d="M14.7168 10.2913H2.37467C2.16471 10.2913 1.96335 10.2079 1.81488 10.0595C1.66642 9.91101 1.58301 9.70965 1.58301 9.49968C1.58301 9.28972 1.66642 9.08836 1.81488 8.93989C1.96335 8.79142 2.16471 8.70802 2.37467 8.70802H14.7168L10.5209 4.51218C10.4386 4.44061 10.3719 4.3528 10.3252 4.25426C10.2784 4.15571 10.2525 4.04856 10.249 3.93953C10.2456 3.8305 10.2648 3.72193 10.3053 3.62065C10.3458 3.51937 10.4068 3.42755 10.4845 3.35096C10.5622 3.27438 10.6549 3.21467 10.7567 3.17559C10.8586 3.13651 10.9674 3.1189 11.0764 3.12387C11.1853 3.12883 11.2921 3.15627 11.39 3.20445C11.4878 3.25263 11.5747 3.32051 11.6451 3.40385L17.1868 8.94552C17.3318 9.0935 17.4131 9.29246 17.4131 9.49968C17.4131 9.7069 17.3318 9.90586 17.1868 10.0538L11.6451 15.5955C11.4946 15.7264 11.3002 15.7956 11.1009 15.7893C10.9015 15.7831 10.7119 15.7018 10.5699 15.5618C10.4279 15.4218 10.3439 15.2333 10.3349 15.0341C10.3258 14.8349 10.3922 14.6395 10.5209 14.4872L14.7168 10.2913V10.2913Z"
                  fill="white"
                />
              </svg>
            </nuxt-link>
          </div>
        </div>
      </div>
    </Footer>
  </div>
</template>

<script>
import { animateElementsTimeline } from '~/helpers';
import InputAutocomplete from '~/components/input/InputAutocomplete';
import Footer from '~/components/Footer';

export default {
  transition: 'transition-fade',

  components: {
    InputAutocomplete, // since it's on the main frame, load sync
    Footer
  },

  data: () => ({
    // state
    expertTag: null,
    displayTag: false,
    profilesData: [
      {
        imageSrc: require('~/assets/images/profil_img_1.jpg'),
        imageAlt: 'profil image',
        name: 'Victoria',
        job: 'Marketing Director',
        keywords: ['Strategy'],
        city: 'Paris',
        startingPrice: '60',
        averageDuration: '20 min',
        rating: {
          note: 4.45,
          count: 123
        }
      },
      {
        imageSrc: require('~/assets/images/profil_img_2.jpg'),
        imageAlt: '',
        name: 'Gabriel',
        job: 'SEO Specialist',
        keywords: ['SEO', 'Emailing'],
        city: 'New York',
        averageDuration: '20 min',
        rating: {
          note: 4.45,
          count: 123
        }
      },
      {
        imageSrc: require('~/assets/images/profil_img_3.jpg'),
        imageAlt: '',
        name: 'Damien',
        job: 'Job title',
        keywords: ['Keyword', 'Test'],
        city: 'New York',
        averageDuration: '20 min',
        rating: {
          note: 4.45,
          count: 123
        }
      },
      {
        imageSrc: require('~/assets/images/profil_img_4.jpg'),
        imageAlt: '',
        name: 'Daoud',
        job: 'Job title',
        keywords: ['Keyword', 'Test'],
        city: 'New York',
        averageDuration: '20 min',
        rating: {
          note: 4.45,
          count: 123
        }
      },
      {
        imageSrc: require('~/assets/images/profil_img_1.jpg'),
        imageAlt: 'profil image',
        name: 'Victoria',
        job: 'Marketing Director',
        keywords: ['Strategy'],
        city: 'Paris',
        startingPrice: '60',
        averageDuration: '20 min',
        rating: {
          note: 4.45,
          count: 123
        }
      }
    ],
    searchValue: null,
    searchData: [
      'Design',
      'Entrepreneurship',
      'Marketing',
      'Accounting',
      'Payroll',
      'HR',
      'Hiring',
      'Team management',
      'Engineering'
    ]
  }),

  computed: {
    searchSuggestions() {
      if (!this.searchValue || !this.searchValue.length) {
        return null;
      }
      // Return max 5 results that includes the text
      return this.searchData.reduce((acc, val) => {
        return acc.length < 5 &&
          val.toLowerCase().includes(this.searchValue.toLowerCase())
          ? [...acc, val]
          : acc;
      }, []);
    }
  },

  mounted() {
    if (process.browser) {
      this.initAnimations();
    }
  },

  methods: {
    onSelectSuggestion(item) {
      this.expertTag = item;
      this.displayTag = true;
      this.openSignup();
    },

    onSuggestionsEnter(val) {
      this.expertTag = val;
      this.displayTag = false;
      this.openSignup();
    },

    openSignup() {
      this.$router.push({
        name: 'signup',
        params: { skills: this.expertTag }
      });
    },

    /**
     * Register every anim and launch them
     */
    initAnimations() {
      animateElementsTimeline('#section-advantage', [
        '#section-advantage-1',
        '#section-advantage-2',
        '#section-advantage-3'
      ]);
      animateElementsTimeline('#section-feature', [
        '#section-feature-title',
        '#section-feature-button',
        '#section-feature-demo',
        '#section-feature-card-1',
        '#section-feature-card-2',
        '#section-feature-card-3'
      ]);
      animateElementsTimeline('#section-experts', [
        '#section-experts-title',
        '#section-experts-text',
        '#section-experts-button'
      ]);
      animateElementsTimeline('#section-experts-demo', [
        '#section-experts-demo-1',
        '#section-experts-demo-2',
        '#section-experts-demo-3',
        '#section-experts-demo-4',
        '#section-experts-demo-5'
      ]);
      animateElementsTimeline('#section-footer', [
        '#section-footer-title',
        '#section-footer-text',
        '#section-footer-button'
      ]);
    }
  }
};
</script>

<style lang="postcss" scoped>
/* Hero section */
.hero {
  @apply flex flex-col justify-center items-center relative;
  height: 550px;
  background-color: rgba(249, 249, 249, 0.8);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 90%, #ffffff 100%),
    rgba(249, 249, 249, 0.8);

  @screen md {
    height: 700px;
  }

  &::before {
    position: absolute;
    bottom: 0%;
    left: 30%;
    content: '';
    width: 120%;
    height: 80%;
    transform: rotate(35deg);
    opacity: 0.2;
    background-image: url('~assets/images/blur-1.png');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 0;

    @screen md {
      bottom: auto;
      left: auto;
      top: -20%;
      right: -15%;
      content: '';
      width: 55%;
      height: 130%;
      transform: rotate(0deg);
    }
  }
}

.hero-title {
  @apply font-serif text-black text-6xl leading-none text-center tracking-tight-plus mt-8;
  font-size: 1.8125rem;
  line-height: 2.125rem;
  @screen md {
    font-size: 3.75rem;
    line-height: 4rem;
  }
  @screen xl {
    /* @apply text-left; */
  }
}

.hero-description {
  @apply text-xs text-gray-600 leading-none text-center mt-2;
  max-width: 820px;
  margin-top: 10px;
  @screen md {
    @apply text-xl;
    margin-top: 20px;
  }
  @screen xl {
    /* @apply text-left; */
  }
}

.inputautocomplete {
  @apply mt-16 mx-auto w-full;
  max-width: 480px;
  @screen md {
    @apply mt-20 mx-auto;
  }
  @screen xl {
    @apply mt-20;
    max-width: 480px;
  }
}

/* Demo section */
.demo-container {
  @apply rounded-xl;
  .demo-video-container {
    @apply rounded-xl h-full bg-gray-100 relative mx-auto;
    width: 80%;
    max-width: 375px;
    max-height: 667px;
    box-shadow: 0px 25px 50px rgba(0, 0, 0, 0.25);

    @screen md {
      @apply w-full h-full;
    }

    img {
      @apply rounded-xl relative;
    }
    &::after {
      @apply absolute inset-0 w-full h-full rounded-xl;
      content: '';
      box-shadow: inset 0px 0px 90px rgba(0, 0, 0, 0.1),
        inset 0px 0px 10px rgba(0, 0, 0, 0.07);
    }
  }
}

.feature-card {
  @apply p-8 rounded-xl mb-10 relative bg-whitish overflow-hidden;
  max-width: 330px;

  &:first-child {
    span {
      color: #e7e7f6;
    }
  }
  &:nth-child(2) {
    span {
      color: #fbeee4;
    }
  }
  &:nth-child(3) {
    span {
      color: #f6dde4;
    }
  }

  span {
    @apply text-6xl font-medium tracking-tighter leading-none;
    position: absolute;
    top: -20px;
    left: -20px;
    color: #fbeee4;
  }

  h5 {
    @apply text-base text-black mt-12 font-medium leading-tight;
  }
  p {
    @apply text-gray-600 text-base mt-6;
    line-height: 1.375rem;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

/* Sections / advantages */
.container-title {
  @apply font-serif text-black text-2xl leading-none text-center tracking-tight mx-auto;
  @screen md {
    @apply text-4xl;
  }
}
.container-text {
  @apply text-base text-gray-600 mt-5 text-center mx-auto;
  line-height: 1.375rem;
  @screen md {
    @apply text-lg;
  }
}

/* Experts section */
#section-experts {
  padding-bottom: 240px;
  position: relative;
  background: linear-gradient(
    180deg,
    rgba(249, 249, 249, 0) 30.73%,
    #f9f9f9 100%
  );
}

.fake-results {
  @apply relative max-w-sm mt-20 mx-auto;

  @screen md {
    @apply mx-auto;
  }
}

.fake-card {
  @apply absolute flex items-end rounded-xl overflow-hidden;
  background-color: white;
  width: 320px;
  height: 140px;
  padding: 15px;
  box-shadow: 0px 0.913195px 4.51343px rgba(0, 0, 0, 0.0232426),
    0px 2.19453px 9.32472px rgba(0, 0, 0, 0.0296059),
    0px 4.13211px 15.0352px rgba(0, 0, 0, 0.0329147),
    0px 7.37098px 23.0322px rgba(0, 0, 0, 0.035353),
    0px 13.7866px 37.3659px rgba(0, 0, 0, 0.0386295),
    0px 33px 80px rgba(0, 0, 0, 0.05);

  .img-container {
    position: relative;
    width: 80px;
    height: 110px;
  }

  .card-badge {
    padding: 4px 8px;
  }

  &:nth-child(1) {
    top: 0;
    left: 32px;
    z-index: 12;
  }
  &:nth-child(2) {
    right: -140px;
    top: 65px;
    z-index: 10;
  }
  &:nth-child(3) {
    top: 90px;
    left: -140px;
    z-index: 9;
  }
  &:nth-child(4) {
    top: 162px;
    right: -180px;
    z-index: 8;
  }
  &:nth-child(5) {
    top: 185px;
    left: -20%;
    z-index: 7;
  }
}
</style>
